import React from "react";
import { observer } from "mobx-react-lite";
import { appStore } from "@/app_store";
import { Clickable } from "@/components/toolkit/Clickable";
import "./s.navigation_bar.css";

export const NavigationBar = observer(() => {
    const { canGoBack, canGoForward } = appStore.state;
    return (
        <div className="navigation_bar">
            <Clickable onClick={() => appStore.state.goBack()}>
                <button className="navigation_bar__btn" title="Go back" disabled={!canGoBack}>←</button>
            </Clickable>
            <Clickable onClick={() => appStore.state.goForward()}>
                <button className="navigation_bar__btn" title="Go forward" disabled={!canGoForward}>→</button>
            </Clickable>
        </div>
    );
});
